import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { adminLogin, adminMe } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("kh_admin_token");
    if (!token) {
      setLoading(false);
      return;
    }
    adminMe()
      .then((d) => setAdmin(d))
      .catch(() => localStorage.removeItem("kh_admin_token"))
      .finally(() => setLoading(false));
  }, []);

  const login = useCallback(async (email, password) => {
    const data = await adminLogin({ email, password });
    localStorage.setItem("kh_admin_token", data.access_token);
    setAdmin({ email: data.email, role: "admin" });
    return data;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("kh_admin_token");
    setAdmin(null);
  }, []);

  return (
    <AuthContext.Provider value={{ admin, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
};
